import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import DContext from '../../context/DContext';

import logo from '../../assets/images/logo/light-logo.png';
import toast from 'react-hot-toast';
import { COMP_INFO } from '../../config';


const ForgotPassword = () => {

    const navigate = useNavigate();
    //const {redirecturl} = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const { authState, authDispatch, login, logout } = useContext(DContext);
    const { user } = authState;

    const [loginInfo, setLoginInfo] = useState({
        "username": "",
        "password": ""
    });

    const [btnDisabled, setBtnDisabled] = useState(false);
    const [btnText, setBtnText] = useState("Submit");

    const handleChange = (e) => {
        setLoginInfo({ ...loginInfo, [e.target.name]: e.target.value })
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setBtnDisabled(true);
        setBtnText("Please Wait...");
        //const loginRes = await login(loginInfo);
        const loginRes = {
            status: "success",
            message: "Hello Tej Pratap",
            data: {
                token: "1232109234131313213"
            }
        }
        if (loginRes.status && loginRes.status == "success") {
            toast.success(loginRes.message);
            localStorage.setItem('token', loginRes.data.token)
            authDispatch({ type: "LOGIN", payload: { firstName: "Tej Pratap" } });
            //redirectRoute();
        } else {
            toast.error(loginRes.response ? loginRes.response.data.message : loginRes.message);
            setBtnDisabled(false);
            setBtnText("Login");
        }


    }

    const redirectRoute = () => {
        let redirectUrl = searchParams.get('redirecturl')
        if (redirectUrl !== null) {
            console.log("redirect url found", redirectUrl);
            navigate(`/${redirectUrl}`);
        } else {
            navigate("/");
        }
    }

    useEffect(() => {

    }, [])

    return (
        <>
            <div className="auth_login">
                <div className="auth_bg">
                    <div className="auth_content">
                        <div className="flex50 ">
                            <div className="auth_left">
                                <div className="bg_caption">
                                    <div className="bg_caption_welcome">
                                        <Link to="/">
                                            <img src={logo} className="mb-3" alt="" />
                                        </Link>
                                        <h4>{COMP_INFO.NAME}</h4>
                                        {/* <div className="bg_caption_signup">
                                            <p>Reset Password</p>
                                            <Link to="/login">Login</Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex50">
                            <div className="auth_right" style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                padding: "48px 40px", background: "rgba(255,255,255,0.92)",
                                backdropFilter: "blur(24px)"
                            }}>
                                <div style={{ width: "100%", maxWidth: "400px" }}>

                                    {/* Header */}
                                    {/* <div style={{ marginBottom: "32px" }}>
                                        <div style={{
                                            width: "46px", height: "46px", borderRadius: "14px",
                                            background: "#e8edf8", display: "flex",
                                            alignItems: "center", justifyContent: "center", marginBottom: "14px"
                                        }}>
                                            <i className="bi bi-key-fill" style={{ fontSize: "18px", color: "#2d4f8e" }}></i>
                                        </div>
                                        <h4 style={{ fontWeight: "800", color: "#1e3a6e", fontSize: "20px", marginBottom: "4px" }}>
                                            Reset Password
                                        </h4>
                                        <p style={{ color: "#a0aec0", fontSize: "13px", margin: 0 }}>
                                            Enter your verification code and set a new password
                                        </p>
                                    </div> */}

                                    <form onSubmit={handleSubmit}>

                                        {/* Verification Code */}
                                        <div style={{ marginBottom: "14px" }}>
                                            <label style={{
                                                fontSize: "11px", fontWeight: "700", color: "#a0aec0",
                                                textTransform: "uppercase", letterSpacing: "0.8px",
                                                display: "block", marginBottom: "8px"
                                            }}>Verification Code</label>
                                            <div style={{ position: "relative" }}>
                                                <i className="bi bi-shield-check" style={{
                                                    position: "absolute", left: "14px", top: "50%",
                                                    transform: "translateY(-50%)", color: "#c0cad8", fontSize: "14px"
                                                }}></i>
                                                <input
                                                    type="text" name="username" id="username"
                                                    placeholder="Enter verification code"
                                                    onChange={handleChange}
                                                    style={{
                                                        width: "100%", padding: "12px 14px 12px 40px",
                                                        border: "1.5px solid #e8ecf4", borderRadius: "10px",
                                                        fontSize: "13px", color: "#1e3a6e", background: "#fafbfd",
                                                        outline: "none", transition: "border-color 0.15s, box-shadow 0.15s"
                                                    }}
                                                    onFocus={e => {
                                                        e.target.style.borderColor = "#5b84c4";
                                                        e.target.style.boxShadow = "0 0 0 3px rgba(91,132,196,0.12)";
                                                    }}
                                                    onBlur={e => {
                                                        e.target.style.borderColor = "#e8ecf4";
                                                        e.target.style.boxShadow = "none";
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* New Password */}
                                        <div style={{ marginBottom: "14px" }}>
                                            <label style={{
                                                fontSize: "11px", fontWeight: "700", color: "#a0aec0",
                                                textTransform: "uppercase", letterSpacing: "0.8px",
                                                display: "block", marginBottom: "8px"
                                            }}>New Password</label>
                                            <div style={{ position: "relative" }}>
                                                <i className="bi bi-lock" style={{
                                                    position: "absolute", left: "14px", top: "50%",
                                                    transform: "translateY(-50%)", color: "#c0cad8", fontSize: "14px"
                                                }}></i>
                                                <input
                                                    type="password" name="password" id="password"
                                                    placeholder="Enter new password"
                                                    onChange={handleChange}
                                                    style={{
                                                        width: "100%", padding: "12px 14px 12px 40px",
                                                        border: "1.5px solid #e8ecf4", borderRadius: "10px",
                                                        fontSize: "13px", color: "#1e3a6e", background: "#fafbfd",
                                                        outline: "none", transition: "border-color 0.15s, box-shadow 0.15s"
                                                    }}
                                                    onFocus={e => {
                                                        e.target.style.borderColor = "#5b84c4";
                                                        e.target.style.boxShadow = "0 0 0 3px rgba(91,132,196,0.12)";
                                                    }}
                                                    onBlur={e => {
                                                        e.target.style.borderColor = "#e8ecf4";
                                                        e.target.style.boxShadow = "none";
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Confirm Password */}
                                        <div style={{ marginBottom: "28px" }}>
                                            <label style={{
                                                fontSize: "11px", fontWeight: "700", color: "#a0aec0",
                                                textTransform: "uppercase", letterSpacing: "0.8px",
                                                display: "block", marginBottom: "8px"
                                            }}>Confirm Password</label>
                                            <div style={{ position: "relative" }}>
                                                <i className="bi bi-lock-fill" style={{
                                                    position: "absolute", left: "14px", top: "50%",
                                                    transform: "translateY(-50%)", color: "#c0cad8", fontSize: "14px"
                                                }}></i>
                                                <input
                                                    type="password" name="confirmPassword" id="confirmPassword"
                                                    placeholder="Confirm new password"
                                                    onChange={handleChange}
                                                    style={{
                                                        width: "100%", padding: "12px 14px 12px 40px",
                                                        border: "1.5px solid #e8ecf4", borderRadius: "10px",
                                                        fontSize: "13px", color: "#1e3a6e", background: "#fafbfd",
                                                        outline: "none", transition: "border-color 0.15s, box-shadow 0.15s"
                                                    }}
                                                    onFocus={e => {
                                                        e.target.style.borderColor = "#5b84c4";
                                                        e.target.style.boxShadow = "0 0 0 3px rgba(91,132,196,0.12)";
                                                    }}
                                                    onBlur={e => {
                                                        e.target.style.borderColor = "#e8ecf4";
                                                        e.target.style.boxShadow = "none";
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Submit */}
                                        <button
                                            type="submit" disabled={btnDisabled}
                                            style={{
                                                width: "100%", padding: "13px",
                                                background: btnDisabled
                                                    ? "#c9d6ee"
                                                    : "linear-gradient(135deg, #2d4f8e 0%, #5b84c4 100%)",
                                                color: "white", border: "none", borderRadius: "12px",
                                                fontSize: "14px", fontWeight: "700", letterSpacing: "0.3px",
                                                cursor: btnDisabled ? "not-allowed" : "pointer",
                                                transition: "all 0.2s", marginBottom: "20px",
                                                boxShadow: btnDisabled ? "none" : "0 4px 14px rgba(45,79,142,0.28)"
                                            }}
                                            onMouseEnter={e => {
                                                if (!btnDisabled) {
                                                    e.currentTarget.style.transform = "translateY(-1px)";
                                                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(45,79,142,0.38)";
                                                }
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.transform = "";
                                                e.currentTarget.style.boxShadow = btnDisabled ? "none" : "0 4px 14px rgba(45,79,142,0.28)";
                                            }}
                                        >
                                            <i className={`bi ${btnDisabled ? "bi-hourglass-split" : "bi-arrow-repeat"} me-2`}></i>
                                            {btnText}
                                        </button>

                                        {/* Back to login */}
                                        <div style={{ textAlign: "center" }}>
                                            <Link to="/login" style={{ textDecoration: "none" }}>
                                                <span style={{ fontSize: "12px", color: "#5b84c4", fontWeight: "600" }}>
                                                    <i className="bi bi-arrow-left me-1" style={{ fontSize: "11px" }}></i>
                                                    Back to Login
                                                </span>
                                            </Link>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPassword